// extracted by mini-css-extract-plugin
export default {"MetadataSidebarContainer":"MetadataSidebar-module__MetadataSidebarContainer--Q36lm","CreateIssueAssigneesSection":"MetadataSidebar-module__CreateIssueAssigneesSection--CPHmR"};